// Contact.js
import React from "react";
import { useForm, ValidationError } from "@formspree/react";
import { Container, Form, Button } from "react-bootstrap";
import Particle from "../Particle";

function Contact() {
    const [state, handleSubmit] = useForm("mqagrgvr");

    if (state.succeeded) {
        return (
            <div className="contact-section">
                <Particle />

                <Container className="contact-container">
                    <h2 className="contact-title">Message Sent</h2>
                    <p className="contact-subtext">
                        Thanks for your message! I’ll get back to you soon.
                    </p>
                </Container>
            </div>
        );
    }

    return (
        <div className="contact-section">
            <Particle />  {/* ✅ Added here */}

            <Container className="contact-container">
                <div className="contact-inner">
                    <h2 className="contact-title">Contact Me</h2>

                    <Form onSubmit={handleSubmit} className="contact-form">
                        <Form.Group className="mb-4">
                            <Form.Label className="contact-label">Email Address</Form.Label>
                            <Form.Control
                                id="email"
                                type="email"
                                name="email"
                                required
                                className="contact-input"
                            />
                            <ValidationError prefix="Email" field="email" errors={state.errors} />
                        </Form.Group>

                        <Form.Group className="mb-4">
                            <Form.Label className="contact-label">Your Message</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={5}
                                id="message"
                                name="message"
                                required
                                className="contact-textarea"
                            />
                            <ValidationError prefix="Message" field="message" errors={state.errors} />
                        </Form.Group>

                        <Button type="submit" className="contact-button">
                            {state.submitting ? "Sending…" : "Send Message"}
                        </Button>
                    </Form>
                </div>
            </Container>
        </div>
    );
}

export default Contact;
